var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1591 1.70508C12.2822 1.70511 14.3368 2.45568 15.96 3.82413C17.5832 5.19257 18.6704 7.09078 19.0294 9.18327C19.3883 11.2758 18.996 13.4278 17.9218 15.259C16.8476 17.0902 15.1605 18.4827 13.1589 19.1904C11.1572 19.8981 8.96987 19.8753 6.98336 19.1262C4.99686 18.3771 3.33913 16.9499 2.30316 15.0967C1.26719 13.2436 0.919695 11.0839 1.32208 8.99929C1.72447 6.91472 2.85083 5.0395 4.5021 3.70508",
    stroke: "#EE3A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15918 3.20508L5.15918 3.20508L5.15918 7.20508",
    stroke: "#EE3A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.d7ba237cc4d59b1d86d68170143f4071.svg";
export { ForwardRef as ReactComponent };